module.exports = __webpack_public_path__ + "img/white-glove-delivery-available.c99a556.svg";